import { useQuery } from "@tanstack/react-query";
import axiosInstance from "@/lib/axios";
import { leadsEndpoints } from "@/config/endpoints";

export interface ChatLeadResult {
  id: number;
  name: string;
  phone: string;
  email: string;
  stage?: string;
}

/** Fetches leads for the "New Chat" view. Shows recent leads by default, filters on search. */
export function useChatLeadSearch(search: string) {
  const query = useQuery<ChatLeadResult[]>({
    queryKey: ["chat-lead-search", search],
    queryFn: async () => {
      const params: any = { limit: 20, page: 1 };
      if (search.trim()) params.search = search.trim();

      const res = await axiosInstance.get(leadsEndpoints, { params });
      const raw = res.data?.leads || res.data?.data || [];
      return raw.map(
        (lead: any): ChatLeadResult => ({
          id: lead.id,
          name: lead.name || "Unknown",
          phone: lead.phone || "",
          email: lead.email || "",
          stage: lead.stage?.name,
        })
      );
    },
    staleTime: 1000 * 30,
  });

  return {
    leads: query.data || [],
    isSearching: query.isLoading,
  };
}
